import { Col, Container, Form } from 'reactstrap';
import React, { useState, useEffect } from 'react';
// Redux
import moment from 'moment';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
// actions
import {
  getLabRequestDeliveryResults,
  addNewLabRequestDeliveryResult,
  updateLabRequestDeliveryResult,
  deleteLabRequestDeliveryResult
} from '../../../../store/labCitec/labRequestDeliveryResult/actions';
import {
  getLabRequestDeliveryResultPartials,
  addNewLabRequestDeliveryResultPartial,
  updateLabRequestDeliveryResultPartial,
  deleteLabRequestDeliveryResultPartial
} from '../../../../store/labCitec/labRequestDeliveryResultPartial/actions';
import { getLabRequestReports } from '../../../../store/labCitec/labRequestReport/actions';
import { getLabRequestReportAuxs } from '../../../../store/labCitec/labRequestReportAux/actions';

import { StatusModal } from './StatusModal';
import {requestStatus, statuses} from '../../../../constants';
import { AddFinalReportModal } from './addFinalReportModal';
import { AddPartialReportModal } from './addPartialReportModal';
import Table1 from '../../../../components/Common/TableContainer';
import { PartialReportStatusModal } from './PartialReportStatusModal';
import { EditDatePartialReportModal } from './editDatePartialReportModal';
import { ConfirmationModal } from '../../../../components/Common/ConfirmationModal';
import { TableItemDeleteModal } from '../../../../components/Common/TableItemDeleteModal';
import { AnalysisRequestLastUpdate } from '../../../../components/Common/AnalysisRequestLastUpdate';
import { BaseCustomButton } from '../../../../shared';
import { userRoles } from '../../../../shared';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import {NotifyButton} from "../../Components";

export const LabCitecResultsTab = ({ props, updateResultStatus, id, labRequest, advisers, activeTab, status, generalStatus }) => {

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showModal6, setShowModal6] = useState(false);
  const [showModal7, setShowModal7] = useState(false);
  const [showModal8, setShowModal8] = useState(false);
  const [showModal9, setShowModal9] = useState(false);

  const [rowInfo, setRowInfo] = useState();
  const [rowInfo2, setRowInfo2] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdate2, setIsUpdate2] = useState(false);

  // Add Partial results check hook
  let [checkedOps, setCheckOp] = useState([]);
  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : '';

  // * Redux
  const dispatch = useDispatch();

  const booleanValidation = React.useMemo(
    () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
    [generalStatus]
  );

  useEffect(() => {
    dispatch(getLabRequestDeliveryResults(`?limit=20&page=0&labRequest=${id}&resultType=Informe final`))
    dispatch(getLabRequestDeliveryResultPartials(`?limit=20&page=0&labRequest=${id}&resultType=Informe parcial`))
    dispatch(getLabRequestReportAuxs(`?limit=20&page=0&labRequest=${id}&authorizationStatus=Autorizado`))
    dispatch(getLabRequestReports(`?limit=20&page=0&labRequest=${id}`))
  }, [activeTab])

  const {
    labRequestDeliveryResults,
    loading,
    labRequestDeliveryResult,
    total,
    currentPage,
    labRequestDeliveryResultPartial,
    loading2,
    labRequestDeliveryResultPartials,
    total2,
    currentPage2,
    labRequestReportAuxs,
    labRequestReportAux,
    loadingReportAuxs,
    totalReportAuxs,
    currentPageReportAuxs,
    labRequestReports
  } = useSelector(state => ({
    labRequestDeliveryResults: state.labRequestDeliveryResultReducer.labRequestDeliveryResults,
    loading: state.labRequestDeliveryResultReducer.loading,
    labRequestDeliveryResult: state.labRequestDeliveryResultReducer.labRequestDeliveryResult,
    total: state.labRequestDeliveryResultReducer.total,
    currentPage: state.labRequestDeliveryResultReducer.currentPage,

    labRequestDeliveryResultPartial: state.labRequestDeliveryResultPartialReducer.labRequestDeliveryResultPartial,
    loading2: state.labRequestDeliveryResultPartialReducer.loading,
    labRequestDeliveryResultPartials: state.labRequestDeliveryResultPartialReducer.labRequestDeliveryResultPartials,
    total2: state.labRequestDeliveryResultPartialReducer.total,
    currentPage2: state.labRequestDeliveryResultPartialReducer.currentPage,

    labRequestReportAuxs: state.labRequestReportAuxReducer.labRequestReportAuxs,
    labRequestReportAux: state.labRequestReportAuxReducer.labRequestReportAux,
    loadingReportAuxs: state.labRequestReportAuxReducer.loading,
    totalReportAuxs: state.labRequestReportAuxReducer.total,
    currentPageReportAuxs: state.labRequestReportAuxReducer.currentPage,

    labRequestReports: state.labRequestReportReducer.labRequestReports,
    labRequestReport: state.labRequestReportReducer.labRequestReport,
  }), shallowEqual);
  // * Redux fin

  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        width: '10%',
        Cell: ({ row }) => (
          <div className='text-primary'>{row?.original?.code ?? '-'}</div>
        ),
      },
      {
        Header: 'Informe Final',
        width: '25%',
        Cell: ({ row }) => (
          <div className='text-primary'>{row?.original?.description ?? '-'}</div>
        ),
      },
      {
        Header: 'Fecha de Atención',
        width: "13%",
        Cell: ({ row }) => (
          <div className='text-center'>{row.original.datedAt ? moment(row.original.datedAt).utc().format("YYYY-MM-DD") : '-'}</div>
        ),
      },
      {
        Header: 'Fecha de Entrega de Informe',
        width: "13%",
        Cell: ({ row }) => (
          <div className='text-center'>{row.original.deliveryDatedAt ? moment(row.original.deliveryDatedAt).utc().format("YYYY-MM-DD") : '-'}</div>
        ),
      },
      {
        Header: 'Documentación Soporte',
        width: '20%',
        Cell: ({ row }) => (
          <a href={`${row?.original?.supportedDocumentation}`} target="_blank" rel="noreferrer">
            <div className="mdi mdi-36px mdi-file-pdf p-2" style={{ color: 'red' }} ></div>
          </a>
        ),
      },
      {
        Header: 'Estatus',
        width: '10%',
        Cell: ({ row }) => (
          row.original.deliveryResultStatus === 'Autorizado' ?
            <div className='text-success'>{row.original.deliveryResultStatus}</div> :
            row.original.deliveryResultStatus === 'Rechazado' ?
              <div className='text-danger'>{row.original.deliveryResultStatus}</div> :
              <div className='text-warning'>{row.original.deliveryResultStatus}</div>
        ),
      },
      {
        width: '15%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div className="page-title-box d-flex align-items-center justify-content-center row">
            <BaseCustomButton
              disabled={
                (role === userRoles.laboratorist ) || 
                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
              }
              color="primary"
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-flag-checkered mdi-18px"
              label="Estatus"
              onClick={() => { editFinalReportStatusModal(row.original) }}
            />
            <BaseCustomButton
              disabled={
                (generalStatus === statuses.FINISHED) || 
                (generalStatus === statuses.CANCELLED)
              }
              color="success"
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-lead-pencil mdi-18px"
              label="Editar"
              onClick={() => { editFinalReportModal(row.original) }}
            />
            <BaseCustomButton
              disabled={
                (generalStatus === statuses.FINISHED) || 
                (generalStatus === statuses.CANCELLED)
              }
              color="danger"
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-lead-pencil mdi-18px"
              label="Eliminar"
              onClick={() => {
                setShowModal8(true)
                setRowInfo2(row.original)
              }}
            />
          </div>
        ),
      },
    ],
    [role, generalStatus, statuses, userRoles]
  )

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'ID',
        width: "10%",
        Cell: ({ row }) => (
          <div className='text-primary'>{row.original.labRequestDeliveryResultAuxiliar[0]?.labRequestReportAuxiliar.code ?? '-'}</div>
        ),
      },
      {
        Header: 'Informe Parcial',
        width: '25%',
        Cell: ({ row }) => (
          <div className='text-primary'>{row.original.labRequestDeliveryResultAuxiliar[0]?.labRequestReportAuxiliar?.name ?? '-'}</div>
        ),
      },
      {
        Header: 'Edad',
        width: 20,
        Cell: ({ row }) => (
          <div className='text-primary'>{row.original.labRequestDeliveryResultAuxiliar[0]?.labRequestReportAuxiliar?.age ?? '-'}</div>
        ),
      },
      {
        Header: 'Fecha de Atención',
        width: "13%",
        Cell: ({ row }) => (
          <div className='text-left'>{row.original.labRequestDeliveryResultAuxiliar[0]?.labRequestReportAuxiliar?.datedAt ? moment(row.original.labRequestDeliveryResultAuxiliar[0]?.labRequestReportAuxiliar?.datedAt).utc().format("YYYY-MM-DD") : '-'}</div>
        ),
      },
      {
        Header: 'Fecha de Entrega de Informe',
        width: "13%",
        Cell: ({ row }) => (
          <div className='text-left'>{row.original.deliveryDatedAt ? moment(row.original.deliveryDatedAt).utc().format("YYYY-MM-DD") : '-'}</div>
        ),
      },
      {
        Header: 'Documentación Soporte',
        width: '12%',
        Cell: ({ row }) => (
          <div>
            <a href={`${row?.original?.supportedDocumentation}`} target="_blank" rel="noreferrer">
              <div className="mdi mdi-36px mdi-file-pdf p-2" style={{ color: 'red' }} ></div>
            </a>
          </div>
        ),
      },
      {
        Header: 'Estatus',
        width: '10%',
        Cell: ({ row }) => (
          row.original.deliveryResultStatus === 'Autorizado' ?
            <div className='text-success'>{row.original.deliveryResultStatus}</div> :
            row.original.deliveryResultStatus === 'Rechazado' ?
              <div className='text-danger'>{row.original.deliveryResultStatus}</div> :
              <div className='text-warning'>{row.original.deliveryResultStatus}</div>
        ),
      },
      {
        width: '18%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div className="page-title-box d-flex align-items-center justify-content-center row">
            <BaseCustomButton
              disabled={
                (role === userRoles.laboratorist ) || 
                (role === userRoles.technicalAdvisor) || 
                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
              }
              color="primary"
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-flag-checkered mdi-18px"
              label="Estatus"
              onClick={() => { openPartialReportStatus(row.original) }}
            />
            <BaseCustomButton
              disabled={
                (role === userRoles.technicalAdvisor) || 
                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
              }
              color='success'
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-calendar-check mdi-18px"
              label='Fecha y Documentación'
              onClick={() => { openEditPartialReport(row.original) }}
            />
            <BaseCustomButton
              disabled={
                (role === userRoles.technicalAdvisor) || 
                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
              }
              color="danger"
              outline
              className='col-10 mb-2 p-1'
              icon='mdi-delete mdi-18px'
              label='Eliminar'
              onClick={() => {
                setShowModal2(true)
                setRowInfo(row.original) }
              }
            />
          </div>
        ),
      },
    ],
    [role, generalStatus, statuses, userRoles]
  )

  const recarga = () => {
    window.location.reload();
  }

  const validation2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.id),
      trackingStatus: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.trackingStatus) ?? ''
    },
    validationSchema: Yup.object({
      trackingStatus: Yup.string().required("Defina el estatus"),
    }),
    onSubmit: (values, { resetForm }) => {
      updateResultStatus(values);
      setTimeout(recarga, 900);
    }
  });

  const onUpdate = (values) => {
    setIsUpdate(true)
    setRowInfo(values)
    setShowModal1(true)
  }

  const onDelete = (values) => {
    setRowInfo(values)
    setShowModal2(true)
  }

  const getPagination1 = (params) => {
    dispatch(getLabRequestDeliveryResults(`${params}&labRequest=${id}&resultType=Informe final`))
  }

  const getPagination2 = (params) => {
    dispatch(getLabRequestDeliveryResultPartials(`${params}&labRequest=${id}&resultType=Informe parcial`))
  }

  const getPaginationModal = (params) => {
    dispatch(getLabRequestReportAuxs(`${params}&labRequest=${id}&authorizationStatus=Autorizado`))
  }


  //#region FINAL REPORT ADD, UPDATE, DELETE
  const onDeleteFinalReportConfirmation = () => {
    const obj = {
      id: rowInfo2.id,
    }
    dispatch(deleteLabRequestDeliveryResult(obj))
    setRowInfo2('')
  }

  const editFinalReportModal = (values) => {
    setRowInfo2(values)
    setShowModal7(true)
    setIsUpdate2(true)
  }

  const editFinalReportStatusModal = (values) => {
    setRowInfo2(values)
    setShowModal3(true)
  }

  const onCloseFinalReport = () => {
    setIsUpdate2(false)
  }

  const onChangeFinalReportCallback = (values) => {
    if (isUpdate2) {
      const objToSend = {
        ...values,
        id: rowInfo2.id,
      }
      dispatch(updateLabRequestDeliveryResult(objToSend))
    } else {
      const objToSend = {
        ...values,
        labRequest: id,
        resultType: "Informe final",
        deliveryResultStatus: "Pendiente"
      }
      dispatch(addNewLabRequestDeliveryResult(objToSend))
    }
    setIsUpdate2(false)
  }

  const updateFinalReportStatus = (values) => {
    const objToSend = {
      ...values,
      id: rowInfo2.id,
    }
    dispatch(updateLabRequestDeliveryResult(objToSend))
  }
  //#endregion


  //#region PARTIAL REPORT ADD, UPDATE, DELETE
  const onDeletePartialReportConfirmation = () => {
    dispatch(deleteLabRequestDeliveryResultPartial(rowInfo))
    setRowInfo('')
  }

  const onConfirmPartialReports = () => {
    const objToSend = {
      labRequest: id,
      labRequestReportAuxiliars: checkedOps.map(element => element.id),
      resultType: 'Informe parcial',
      deliveryResultStatus: 'Pendiente',
      description: labRequestReportAuxs[0]?.name,
      datedAt: labRequestReportAuxs[0]?.datedAt,
    }
    dispatch(addNewLabRequestDeliveryResultPartial(objToSend))
    setTimeout(() =>{
      dispatch(getLabRequestDeliveryResultPartials(`?limit=20&page=0&labRequest=${id}&resultType=Informe parcial`))
    }, 1200)
  }

  const openPartialReportStatus = values => {
    setRowInfo(values)
    setShowModal6(true)
  }

  const openEditPartialReport = (values) => {
    setRowInfo(values)
    setShowModal4(true)
  }

  const onUpdatePartialReport = (values) => {
    const objToSend = {
      ...values,
      id: rowInfo.id,
    }
    dispatch(updateLabRequestDeliveryResultPartial(objToSend))
    setTimeout(() =>{
      dispatch(getLabRequestDeliveryResultPartials(`?limit=20&page=0&labRequest=${id}&resultType=Informe parcial`))
    }, 500)
  }

  const modalRespInfo = (values) => {
    setCheckOp(values)
    setShowModal1(false)
    onAcceptConfirmation1()
  }

  const updatePartialReportStatus = (values) => {
    const objToSend = {
      ...values,
      id: rowInfo.id,
    }
    dispatch(updateLabRequestDeliveryResultPartial(objToSend))
    setTimeout(() =>{
      dispatch(getLabRequestDeliveryResultPartials(`?limit=20&page=0&labRequest=${id}&resultType=Informe parcial`))
    }, 400)
  }
  //#endregion

  const onAcceptConfirmation1 = () => {
    setShowModal9(true)
  }

  const modalClose = () => {
    setIsUpdate(false)
  }

  const onAccept = () => {
    validation2.submitForm()
  }

  return (
    <div className="d-flex justify-content-center">
      <Container fluid className="" >
        <Col className="col-12" style={{ padding: 20 }}>
            <Form
              className="form-horizontal mt-2 mb-1"
              onSubmit={(e) => {
                  e.preventDefault();
                  validation2.handleSubmit();
                  return false;
              }}
            >
              <div className="page-title-box d-flex align-items-center">
                <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.updatedBy?.surname ?? ''}`}
                date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de resultados')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`}  />
                <div className="d-flex align-items-end justify-content-end pt-3 w-50">

                  <div className="py-1 ms-1" >
                    <label className='text-primary ml-1'>Status</label>
                    <select
                        disabled={
                          (role === userRoles.technicalAdvisor) || 
                          (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                        }
                        name="trackingStatus"
                        className="form-select text-primary rounded-3"
                        onChange={validation2.handleChange}
                        onBlur={validation2.handleBlur}
                        value={validation2.values.trackingStatus || ""}
                    >
                        {requestStatus.map((dir,index)=>{
                            return <option key={index} value={dir.id}>{dir.value}</option>
                        })}
                    </select>
                  </div>

                  <div className='d-flex align-items-center py-1 ms-1'>
                    <NotifyButton
                      booleanValidation={booleanValidation}
                      pathName={`/process-notification/${id}`}
                    ></NotifyButton>
                  </div>

                  <div className='d-flex align-items-center py-1 ms-1'>
                    <button disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} type='button' onClick={() => { setShowModal5(true) }} className="btn btn-success py-2 w-100 rounded-3" >
                        <span className="mdi mdi-content-save me-2"></span>Guardar
                    </button>
                  </div>
              </div>

            </div>
            <div className='d-flex justify-content-end'>
              <label className='text-primary ml-1'></label>
            <button disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}  type='button' className="btn btn-primary py-2 w-40 rounded-3" onClick={() => { setShowModal7(!showModal7) }}>
                  <span className="mdi mdi-plus-circle-outline me-2"></span>Agregar Informe
                </button>
            </div>
          </Form>

          <div className='row mt-3'>
            <hr className='text-primary' />
          </div>

          <Table1 loading={loading} currentPage={currentPage} getPagination={getPagination1} total={total} isAddTableBorderStrap columns={columns} data={labRequestDeliveryResults} />

          <div className='row mt-3'>
            <hr className='text-primary' />
          </div>

          <div className="d-flex justify-content-end">
            <button disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}  type='button' className="btn btn-primary py-2 w-40 rounded-3" onClick={() => { setShowModal1(!showModal1) }}>
              <span className="mdi mdi-plus-circle-outline me-2"></span>Agregar Informes
            </button>
          </div>

          <Table1 loading={loading2} currentPage={currentPage2} getPagination={getPagination2} total={total2} isAddTableBorderStrap columns={columns2} data={labRequestDeliveryResultPartials} />


          {/* Partial Report Section */}

          <PartialReportStatusModal modalRespInfo={updatePartialReportStatus} requestStatus={rowInfo} props={props} setShowModal={setShowModal6} showModal={showModal6} />

          <AddPartialReportModal /*onChecked={onChecked}*/ labRequestReportAuxs={labRequestReportAuxs} getPagination={getPaginationModal} loading={loadingReportAuxs} total={totalReportAuxs} currentPage={currentPageReportAuxs} props={props} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={modalRespInfo} modalHeader='Registro de Informes Parciales' />

          <ConfirmationModal onAccept={onConfirmPartialReports} showModal={showModal9} setShowModal={setShowModal9} message='Esta acción actualizará los datos de los informes parciales en estatus de aceptados, ¿Desea continuar?' />

          <EditDatePartialReportModal showModal={showModal4} rowInfo={rowInfo} modalClose={modalClose} modalRespInfo={onUpdatePartialReport} props={props} setShowModal={setShowModal4} modalHeader='Informes Parciales' />

          <TableItemDeleteModal onDeleteConfirmation={onDeletePartialReportConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Reporte Parcial' modalBodyLabel={'¿Está seguro que desea borrar el reporte parcial seleccionado?'} />
          {/* Final Report Section */}
          <AddFinalReportModal datedAt={labRequestReports[0]?.endedAt ?? ''} modalClose={onCloseFinalReport} isUpdate={isUpdate2} props={props} showModal={showModal7} rowInfo={rowInfo2} setShowModal={setShowModal7} modalRespInfo={onChangeFinalReportCallback} modalHeader='Registro de Informes Finales' />

          <StatusModal modalRespInfo={updateFinalReportStatus} requestStatus={rowInfo2} props={props} setShowModal={setShowModal3} showModal={showModal3} />

          <TableItemDeleteModal onDeleteConfirmation={onDeleteFinalReportConfirmation} props={props} setShowModal={setShowModal8} showModal={showModal8} modalHeader='Eliminar Reporte Final' modalBodyLabel={'¿Está seguro que desea borrar el reporte final seleccionado?'} />
          <br />

          {/* Modal de cambio de STATUS de SECCIÓN */}
          <ConfirmationModal onAccept={onAccept} showModal={showModal5} setShowModal={setShowModal5} message='¿Estás seguro de cambiar el estatus de la sección de Entrega de Resultados?' />

        </Col>
      </Container>
    </div>
  )
}
